(function($) {
    $.fn.hasScrollBar = function() {
        return this[0] ? this[0].scrollHeight > this.innerHeight() : false;
    }
})(jQuery);

/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
}); 

jQuery(window).ready(function($) {
    // VALIDATION FOR UNIQUE EMAIL ADDRESS ON REGISTRATION
    function uniqueEmailValidator( $el, required, parent ) {
      if (!required) return true;
      return $el.attr('data-unique') !== 'false';
    };
    function strongPasswordValidator( $el, required, parent ) {
      if (!required) return true;
      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})"); // at least 1 lowercase, 1 uppercase, 1 numeric and one special character at least 6 long
      var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"); // (at least 1 lowercase, 1 uppercase) OR (at least one alpha char and a numeric char)  at least 6 long
      return strongRegex.test($el.val());
    };
    Foundation.Abide.defaults.validators['unique_email'] = uniqueEmailValidator;
    Foundation.Abide.defaults.validators['strong_password'] = strongPasswordValidator;
    //
    $("#registration-form #email").on("keyup", function(e) {
        var regEx = new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/);
        var validEmail = regEx.test($(this).val());
        if (validEmail) {
            var data = {
                'action': 'check_user_exists',
                'email': $(this).val(),
                'security': angio_ajax.ajax_nonce
            };
            $.ajax({
                type : "post",
                dataType : "json",
                url : angio_ajax.ajaxurl,
                data : data,
                success: function(response) {
                    var input = $("#registration-form #email");
                    var container = input.closest(".cell");    
                    var label = container.find("label");    
                    var error = container.find(".form-error");
                    var code = -999;
                    if (!isNaN(response.code)) { code = parseInt(response.code); }
                    if (code > 0) {
                        label.addClass("is-invalid-label");
                        input.attr("data-invalid", "");
                        input.attr("data-unique", "false");
                        input.addClass('is-invalid-input');
                        error.html('You are already registered. <a href="/">Click here to log in.</a>');
                        error.addClass('is-visible');
                    } else {
                        label.removeClass("is-invalid-label");
                        input.removeAttr("data-invalid");
                        input.removeAttr("data-unique");
                        input.removeClass('is-invalid-input');
                        error.removeClass('is-visible');
                        error.text('A valid email address is required.');
                        // NOTE: A negative number indicates there was an error. Let it fail silently. Backend will catch it.
                    }
                 }
            });
        }
    });
    // Hide the no-js registration errors 
    // (NOTE: This should not show up for most people as javascript should prevent empty forms)
    $('#btnregister').on('click', function() { $('#nojs-error').hide();   });

    // Occupation smart logic
    $('#user_occupation').on('change', function() {
        setOccupations();
    });

    function setOccupations(init) {
        if (init !== true) { init = false; }
        var val = $('#user_occupation').val();
        $('#user_occupation_secondary').addClass('hide');
        if (!init) { $('#user_occupation_secondary').val(''); }
        $('#user_occupation_secondary').removeAttr('required').removeClass('is-invalid-input');
        $('#job-sub-error').removeClass('is-visible');
        $('#lbl-job').removeClass('is-invalid-label');
        if (!isNaN(val)) {
            val = parseInt(val);
            $.each($('#user_occupation_secondary option'), function() {
                if (!isNaN($(this).data('parent')) && parseInt($(this).data('parent')) === val) {
                    $(this).removeClass('hide').addClass('active');
                    $('#user_occupation_secondary').removeClass('hide');
                    $('#user_occupation_secondary').attr('required', 'required');
                } else {
                    $(this).addClass('hide').removeClass('active');
                }
            });
            if (!$('#user_occupation_secondary').hasClass('hide') && !init) {
                $('#user_occupation_secondary option').first().attr('selected', 'selected');
            }
        }
    }
    setOccupations(true);

    // disable first level nav
    $('.defect-cat-link').on('click', function(e) { e.preventDefault(); });
    $(document).foundation();
	
	var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
	if (!isIE11) {
		$('.scrolla').scrolla({
			mobile: true, // disable animation on mobiles 
			once: true // only once animation play on scroll
		});
	}
    
    // check nav height
    $(window).on('resize', function() {
        var nav = $('.defect-categories');
        if ($(nav).hasScrollBar()) {
            $(nav).removeClass('flexed');
        } else {
            $(nav).addClass('flexed');
        }
    }).resize();
    
    $('.full-screen').on('click', function(e) {
        e.preventDefault();
        var videoUrl = $(this).data('url');
        $('#full-screen-viewer > .video').html('<video src="' + videoUrl + '" playsinline loop autoplay preload="auto"></video>');
        $('#full-screen-viewer').addClass('active');
    });
    $('.cancel-full-screen').on('click', function(e) {
        e.preventDefault();
        $('#full-screen-viewer').removeClass('active');
    });
    $(document).keyup(function(e) {
      if (e.keyCode === 27) { // ESC
        $('#full-screen-viewer').removeClass('active');
      }
    });
});